import { DisplayDataset } from '@cibo/core'
import { MapTheme } from '@cibo/mapgl'
import { useTheme } from '@mui/material'
import { StyleFunction } from 'mapbox-gl'
import { useMemo } from 'react'
import { Layer, Source } from 'react-map-gl/dist/es5'
import { LandReportMapDataLayer } from '../LandReportViewProvider'
import { DataLayer } from './DataLayer'
import { LandReportMapDataLayersProps } from './types'

export const LandReportMapDataLayers = ({
  dataLayer,
  field,
  zoomThreshold = 11,
}: LandReportMapDataLayersProps) => {
  const { palette } = useTheme<MapTheme>()

  const fillOpacity = useMemo(
    () =>
      zoomThreshold
        ? ([
            'interpolate',
            ['linear'],
            ['zoom'],
            zoomThreshold,
            0,
            zoomThreshold + 0.75,
            0.3,
          ] as StyleFunction)
        : 0.3,
    [zoomThreshold]
  )

  const lineOpacity = useMemo(
    () =>
      zoomThreshold
        ? ([
            'interpolate',
            ['linear'],
            ['zoom'],
            zoomThreshold,
            0,
            zoomThreshold + 0.75,
            1,
          ] as StyleFunction)
        : 1,
    [zoomThreshold]
  )

  switch (dataLayer) {
    case LandReportMapDataLayer.ACRES:
      return (
        <Source type="geojson" data={field.feature}>
          <Layer
            id="field-boundary"
            type="fill"
            //@ts-ignore problem with extending PaletteOptions
            paint={{ 'fill-color': palette.secondary.main, 'fill-opacity': fillOpacity }}
          />
          <Layer
            id="field-fill"
            type="line"
            paint={{
              'line-width': 4,
              //@ts-ignore problem with extending PaletteOptions
              'line-color': palette.secondary.dark,
              'line-opacity': lineOpacity,
            }}
          />
        </Source>
      )
    case 'stability':
    case 'soil':
    case 'elevation':
      return (
        <DataLayer
          dataset={dataLayer as DisplayDataset}
          field={field}
          zoomThreshold={zoomThreshold}
        />
      )
    default:
      return null
  }
}
